import castle from "./graphics/jpg/castle.jpg";
import conflux from "./graphics/jpg/conflux.jpg";
import dungeon from "./graphics/jpg/dungeon.jpg";
import fortess from "./graphics/jpg/fortress.jpg";
import inferno from "./graphics/jpg/inferno.jpg";
import necropolis from "./graphics/jpg/necropolis.jpg";
import rampart from "./graphics/jpg/rampart.jpg";
import stronghold from "./graphics/jpg/stronghold.jpg";
import tower from "./graphics/jpg/tower.jpg";
import dirt from "./graphics/jpg/dirt.jpg";
import rough from "./graphics/jpg/rough.jpg";
import subterean from "./graphics/jpg/sub.jpg";
import lava from "./graphics/jpg/lava.jpg";
import grass from "./graphics/jpg/grass.jpg";
import snow from "./graphics/jpg/snow.jpg";
import swamp from "./graphics/jpg/swamp.jpg";
import under from "./graphics/jpg/under.jpg";
import sand from "./graphics/jpg/sand.jpg";
import water from "./graphics/jpg/water.jpg";
import random1 from "./graphics/jpg/random_1.jpg";
import random2 from "./graphics/jpg/random_2.jpg";
import random3 from "./graphics/jpg/random_3.jpg";
import random4 from "./graphics/jpg/random_4.jpg";
import random5 from "./graphics/jpg/random_5.jpg";
import random6 from "./graphics/jpg/random_6.jpg";
import random7 from "./graphics/jpg/random_7.jpg";
import random8 from "./graphics/jpg/random_8.jpg";
import random9 from "./graphics/jpg/random_9.jpg";
import random10 from "./graphics/jpg/random_10.jpg";
import random11 from "./graphics/jpg/random_11.jpg";

const randoms = [
  random1,
  random2,
  random3,
  random4,
  random5,
  random6,
  random7,
  random8,
  random9,
  random10,
  random11,
];
export const CATEGORY_MAPS = {
  CASTLE: castle,
  CONFLUX: conflux,
  DUNGEON: dungeon,
  FORTRESS: fortess,
  INFERNO: inferno,
  NECROPOLIS: necropolis,
  RAMPART: rampart,
  STRONGHOLD: stronghold,
  TOWER: tower,

  dirt,
  lava,
  rough,
  sand,
  subterean,
  grass,
  snow,
  swamp,
  under,
  water,
};

export type CATEGORIES = keyof typeof CATEGORY_MAPS;
export const CATEGORIES = Object.keys(CATEGORY_MAPS).reduce(
  (a, b) => ({ ...a, [b]: b }),
  {} as { [K in keyof typeof CATEGORY_MAPS]: K }
);

export const getRandom = (i: number) => randoms[i % randoms.length];

for (const url of [...Object.values(CATEGORY_MAPS), ...randoms]) {
  const preloadLink = document.createElement("link");
  preloadLink.href = url;
  preloadLink.rel = "preload";
  preloadLink.as = "image";
  if (url === random1) {
    preloadLink.fetchPriority = "high";
  }
  document.head.appendChild(preloadLink);
}
